// @flow

import React from 'react';
import bemify from 'bemify-js';
import { isEmpty } from 'lodash';

import ServiceDropdownItem from 'web-ssr/app/services/components/ServicesSearch/ServiceDropdownItem';
import StatefulChoiceList from 'web-ssr/app/common/components/StatefulChoiceList';
import 'web-ssr/app/services/components/ServicesSearch/ServicesSearchDropdown.scss';

import type {
  appInfoFragment,
  publicAppSearchQuery_getAppsByNameContains_edges,
} from 'web-ssr/graphql/types';

const bem = bemify('services-search-dropdown');

type Props = {
  apps: Array<publicAppSearchQuery_getAppsByNameContains_edges>,
  isDropdownOpen: boolean,
  onSelectService: (service: appInfoFragment) => void,
};

const ServicesSearchDropdown = (props: Props) => {
  const { apps, onSelectService, isDropdownOpen } = props;

  if (!isDropdownOpen) {
    return null;
  }

  const contentNode = (() => {
    if (isEmpty(apps)) {
      return <div className={bem('__no-results')}>No Results!</div>;
    }

    return (
      <StatefulChoiceList
        className={bem('__results-list')}
        isVisible={isDropdownOpen}
        items={apps || []}
        itemValueKey="slug"
        onChoose={onSelectService}
        renderItem={app => {
          return <ServiceDropdownItem app={app} isSelected={app.isSelected} />;
        }}
      />
    );
  })();

  return (
    <div className={bem()}>
      <div className={bem('__list')}>{contentNode}</div>
    </div>
  );
};

export default ServicesSearchDropdown;
